var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenExc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2975 11.2146C23.2975 17.4002 18.283 22.4146 12.0975 22.4146C5.91187 22.4146 0.897461 17.4002 0.897461 11.2146C0.897461 5.02906 5.91187 0.0146484 12.0975 0.0146484C18.283 0.0146484 23.2975 5.02906 23.2975 11.2146ZM13.4975 16.8146C13.4975 17.5878 12.8707 18.2146 12.0975 18.2146C11.3243 18.2146 10.6975 17.5878 10.6975 16.8146C10.6975 16.0415 11.3243 15.4146 12.0975 15.4146C12.8707 15.4146 13.4975 16.0415 13.4975 16.8146ZM12.0975 4.21465C11.3243 4.21465 10.6975 4.84145 10.6975 5.61465V11.2146C10.6975 11.9878 11.3243 12.6146 12.0975 12.6146C12.8707 12.6146 13.4975 11.9878 13.4975 11.2146V5.61465C13.4975 4.84145 12.8707 4.21465 12.0975 4.21465Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenExc);
export default __webpack_public_path__ + "static/media/GreenExc.a4e78a7b150ea7cb7b3c500ca0b68e72.svg";
export { ForwardRef as ReactComponent };